/**
 * SEO 메타·구조화 데이터용 절대 URL 헬퍼.
 *
 * 영구지침: docs/develop/seo/blog-spec.md §8 (Article image 절대 URL), SEO.tsx og:image
 *
 * 순수 함수(별칭 import 없음) — `npm test`(tsx --test)로 단독 실행된다.
 */
export const SITE_URL = 'https://carebalance.co.kr'

/** http(s) 절대 URL 은 그대로, 상대 경로(`/api/v1/files/…`)는 사이트 도메인을 붙인다. */
export function toAbsoluteUrl(pathOrUrl: string): string {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl
  return `${SITE_URL}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`
}
